import React, { useState } from "react";
import { Box, Grid, Typography, Tooltip, IconButton } from "@mui/material";
import { Star, StarBorder } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { toggleFavorite, selectIsFavorite } from "../../slices/favoritesSlice";

const ChannelRow = ({ index, style, channels }) => {
    const dispatch = useDispatch();
    const channel = channels[index];
    const truncatedName = channel.name.length > 20 ? `${channel.name.slice(0, 20)}...` : channel.name;

    // Select favorite state
    const isFavorite = useSelector(selectIsFavorite("live", channel.stream_id));
    const [hover, setHover] = useState(false);

    const handleFavoriteToggle = (event) => {
        event.stopPropagation();
        console.log('is this chan', channel);
        dispatch(toggleFavorite({ mode: "live", id: channel.stream_id, data: channel }));
    };

    return (
        <Box
            key={index}
            style={style}
            sx={{ padding: "8px 0" }}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            <Grid container alignItems="center" sx={{ height: "100%" }}>
                {/* Column for the image */}
                <Grid
                    item
                    xs={3}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                >
                    <img
                        src={channel.stream_icon}
                        alt={channel.name}
                        style={{ maxHeight: "30px", maxWidth: "40px", height: "auto" }}
                    />
                </Grid>

                {/* Column for the channel name */}
                <Grid
                    item
                    xs={7}
                    display="flex"
                    justifyContent="flex-start"
                    alignItems="center"
                    sx={{ height: "100%" }}
                >
                    <Typography
                        sx={{
                            fontSize: 12,
                            color: "#fff",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {truncatedName}
                    </Typography>
                </Grid>

                {/* Column for the favorite icon */}
                {(hover || isFavorite) && (
                    <Grid
                        item
                        xs={2}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Tooltip
                            title={isFavorite ? "Remove from favorites" : "Add to favorites"}
                        >
                            <IconButton size="small" onClick={handleFavoriteToggle}>
                                {isFavorite ? (
                                    <Star sx={{ color: "gold" }} />
                                ) : (
                                    <StarBorder sx={{ color: "#fff" }} />
                                )}
                            </IconButton>
                        </Tooltip>
                    </Grid>
                )}
            </Grid>
        </Box>
    );
};

export default ChannelRow;
